'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeInAppUsageTracker = undefined;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _usageTrackerPublic = require('usage-tracker-public');

var _events = require('conversations-visitor-ui/events.yaml');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var makeInAppUsageTracker = exports.makeInAppUsageTracker = function makeInAppUsageTracker() {
  return (0, _usageTrackerPublic.createTracker)({
    events: _events2.default,
    isExternalHost: false,
    properties: {
      namespace: 'conversations-visitor-ui',
      hubId: _hubspot2.default.get()
    }
  });
};